import React, { useEffect } from 'react';
import { Tab } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import SubmitResetButtonAndValidationError from '~/components/SubmitResetButtonAndValidationError';
import DisplayFormikState from '~/components/DisplayFormikState';

function FormTabManagerContent({ props }) {
    const { formGroups, navTitles, setNavTitles, setResetCount, apiValidationErrors, clearApiValidationErrors } =
        useFormTab();
    // eslint-disable-next-line react/prop-types
    const { handleSubmit, isSubmitting, resetForm, errors, values, submitCount, isValid } = props;

    useEffect(() => {
        //this runs only after form has been submitted.
        if (submitCount === 0) return;

        let errorKeys = Object.keys(errors);
        errorKeys = errorKeys.map((name) => name.toLowerCase());

        navTitles.forEach((title, index) => {
            if (errorKeys.includes(title.name.toLowerCase())) {
                navTitles[index].hasError = true;
            } else {
                navTitles[index].hasError = false;
            }
        });
        setNavTitles(JSON.parse(JSON.stringify(navTitles)));
    }, [isSubmitting, errors]);

    return (
        <>
            <Tab.Content>
                {formGroups.map((item, index) => {
                    const Component = item.component;

                    return (
                        <Tab.Pane
                            eventKey={item.name}
                            key={index}
                        >
                            <Component values={values} />
                        </Tab.Pane>
                    );
                })}
            </Tab.Content>

            <SubmitResetButtonAndValidationError
                isSubmitting={isSubmitting}
                handleSubmit={handleSubmit}
                setResetCount={setResetCount}
                resetForm={resetForm}
                navTitles={navTitles}
                setNavTitles={setNavTitles}
                apiValidationErrors={apiValidationErrors}
                clearApiValidationErrors={clearApiValidationErrors}
                isValid={isValid}
                submitCount={submitCount}
            />
            <DisplayFormikState props={props} />
        </>
    );
}

FormTabManagerContent.propTypes = {
    props: PropTypes.object.isRequired,
};

export default FormTabManagerContent;
